/** FIXME @techdebt - convert to const def per symbol. Detach from object structure. */
export const actions = {
  VIDEO_ATTACHMENTS_FETCH_REQUEST: Symbol('VIDEO_ATTACHMENTS_FETCH_REQUEST'),
  VIDEO_ATTACHMENTS_FETCH_SUCCESS: Symbol('VIDEO_ATTACHMENTS_FETCH_SUCCESS'),
  VIDEO_ATTACHMENTS_FETCH_ERROR: Symbol('VIDEO_ATTACHMENTS_FETCH_ERROR'),
  VIDEO_ATTACHMENTS_RESET: Symbol('VIDEO_ATTACHMENTS_RESET'),
};

export const videoAttachmentsFetchRequestAction = (videoId) => ({
  type: actions.VIDEO_ATTACHMENTS_FETCH_REQUEST,
  payload: {
    videoId,
  },
});

export const videoAttachmentsFetchSuccessAction = (attachments) => ({
  type: actions.VIDEO_ATTACHMENTS_FETCH_SUCCESS,
  payload: {
    attachments,
    total: attachments.length,
  },
});

export const videoAttachmentsFetchErrorAction = () => ({
  type: actions.VIDEO_ATTACHMENTS_FETCH_ERROR,
});

export const videoAttachmentsResetAction = () => ({
  type: actions.VIDEO_ATTACHMENTS_RESET,
});
